import { render, staticRenderFns } from "./ManterFormacoesView.vue?vue&type=template&id=43e63569"
import script from "./ManterFormacoesView.vue?vue&type=script&lang=js"
export * from "./ManterFormacoesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports